"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var useRequest_1 = require("./useRequest");
function Request(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    var request = useRequest_1.default(props);
    return children(request);
}
exports.default = Request;
